module.exports = __webpack_public_path__ + "static/img/reChangJing2.24897b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reChangJing2.png
// module id = c//I
// module chunks = 2